export const testcriteria = [
    {
        mainheading: 'Test details',
        content: [
            {
                headings: [
                    { mode: 'Online mode', details: 'Join from desktop for better performance', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/online-icon1.svg' },
                    { mode: '9 AM to 10 PM', details: 'Available on all days (Monday to Sunday)', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/watch-icon3.svg' },
                    { mode: '60 mins. duration', details: 'To submit your test', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/time-icon2.svg' },
                ]
            }
        ]
    },
    {
        mainheading: 'Eligibility Criteria',
        content: [
            {
                headings: [
                    { mode: 'Class 6th to 12th students', details: 'All State boards, CBSE and ICSE/ISC boards students are eligible for iACST test', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/eight-iocn-4.svg' },
                    { mode: 'Class 5th passing students', details: 'Students moving from 5th to 6th class are also eligible', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/sevnth-icon5.svg' },
                    { mode: 'Class 12th passed students', details: 'Students who have passed class 12th are also eligible', imgicon: 'https://d2flmtdfyoymgx.cloudfront.net/Aakash-Anthe/s3fs-public/inline-images/eight-iocn-4.svg' },
                ]
            }
        ]
    }
];

export const scholarships = [
    {
        targetId: '1',
        heading: 'What is iACST and what does it offer?',
        subheading: 'iACST stands for Instant Admission Cum Scholarship Test. It is an online Scholarship exam that offers students scholarships of up to 90% on for NEET, JEE and Foundation courses.',
        bulletpoints: [
        ],
    },
    {
        targetId: '2',
        heading: 'Who is eligible to appear for iACST?',
        subheading: 'Students studying in Classes 6th to 12th and Class 12th passed are eligible to take the iACST. Students studying in Class 6th can also take iACST. They will be eligible to take admission in courses starting next academic year.',
        bulletpoints: [
        ],
    },
    {
        targetId: '3',
        heading: 'Is there any fee for iACST?',
        subheading: 'iACST is completely free and there is no fee. You can register for iACST online and select your preferred date and time slot for the exam.',
        bulletpoints: [
        ],
    },
    {
        targetId: '4',
        heading: 'What are the benefits of taking iACST?',
        subheading: 'By performing well in iACST, students can receive up to 90% Scholarship, making it an excellent opportunity to get access to quality coaching for NEET, JEE, and foundation courses.',
        bulletpoints: [
        ],
    },
    {
        targetId: '5',
        heading: 'When can I take the iACST exam?',
        subheading: 'iACST is conducted daily, and you can choose any time slot between 9:00 AM and 10:00 PM as per your convenience.',
        bulletpoints: [
        ],
    },
    {
        targetId: '6',
        heading: 'What are the requirements to take the iACST online?',
        subheading: 'We recommend taking the iACST on a desktop or laptop. You need a stable internet connection and a browser to access the test portal.',
        bulletpoints: [
        ],
    },
    {
        targetId: '7',
        heading: 'What should I do if I face technical issues during the test?',
        subheading: 'In case of technical issues, you can contact the iACST Helpline at 18001022727 | Email: or email at <a href= "mailto:acstsupport@aesl.in">acstsupport@aesl.in</a> or fill in this form <a href="https://forms.gle/g9skRtHYSaTxexPL9" target="_blank">https://forms.gle/g9skRtHYSaTxexPL9</a>.',
        bulletpoints: [
        ],
    }
]